import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Building2, Ticket, Users2, Calendar, FileText, LayoutDashboard, ChevronRight } from "lucide-react";

const sections = [
  { key: "cantieri", label: "Cantieri", icon: Building2, color: "amber", desc: "Anagrafica e computi cantieri" },
  { key: "ticket-tecnici", label: "Ticket tecnici", icon: Ticket, color: "blue", desc: "Segnalazioni tecniche" },
  { key: "ticket-subappaltatori", label: "Ticket subappaltatori", icon: Users2, color: "purple", desc: "Comunicazioni con subappaltatori" },
  { key: "calendario", label: "Calendario materiali", icon: Calendar, color: "emerald", desc: "Consegne materiali di tutti i cantieri" },
  { key: "documenti", label: "Documenti", icon: FileText, color: "slate", desc: "Archivio documentale" },
  { key: "dashboard", label: "Dashboard KPI", icon: LayoutDashboard, color: "rose", desc: "Indicatori operativi ed economici" },
];

const colorMap = {
  amber: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
  blue: "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  purple: "bg-purple-500/10 text-purple-600 dark:text-purple-400",
  emerald: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  slate: "bg-slate-500/10 text-slate-700 dark:text-slate-300",
  rose: "bg-rose-500/10 text-rose-600 dark:text-rose-400",
};

export default function GroupHome() {
  const { groupId } = useParams();
  const [group, setGroup] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/groups/${groupId}`).then(r => setGroup(r.data)).catch(() => {});
  }, [groupId]);

  return (
    <div className="max-w-7xl mx-auto">
      <div className="mb-8">
        <p className="text-xs uppercase tracking-widest text-amber-600 dark:text-amber-500 font-semibold">Gruppo cantieri</p>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mt-1" data-testid="group-title">{group?.name || "…"}</h1>
        {group?.description && <p className="text-slate-500 dark:text-slate-400 mt-2">{group.description}</p>}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {sections.map(s => (
          <button key={s.key} onClick={() => navigate(`/g/${groupId}/${s.key}`)} data-testid={`section-${s.key}`} className="text-left">
            <Card className="h-full transition-all hover:shadow-lg hover:-translate-y-0.5 hover:border-amber-500 group">
              <CardContent className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${colorMap[s.color]}`}>
                    <s.icon className="h-6 w-6" />
                  </div>
                  <ChevronRight className="h-5 w-5 text-slate-400 group-hover:text-amber-500 group-hover:translate-x-1 transition-all" />
                </div>
                <h3 className="text-lg font-bold tracking-tight">{s.label}</h3>
                <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">{s.desc}</p>
              </CardContent>
            </Card>
          </button>
        ))}
      </div>
    </div>
  );
}
